import { render } from "./ShopDetails.vue?vue&type=template&id=b719475a&scoped=true"
import script from "./ShopDetails.vue?vue&type=script&lang=js"
export * from "./ShopDetails.vue?vue&type=script&lang=js"

import "./ShopDetails.vue?vue&type=style&index=0&id=b719475a&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b719475a"]])

export default __exports__